import axios from "axios";

const BASE_URL = 'https://hotline.itg.ac.id/api/';

export const api = axios.create({
    baseURL: BASE_URL
});

export const getsPengumuman = ()=> api.get('pengumuman?limit=4');
export const getsAllPengumuman = ()=> api.get('pengumuman');